///<reference path="../require.d.ts"/>

interface City {
    id: number;
    name: string;
    rooms: number;
}

interface Prefecture {
    name: string;
    cities: City[];
}

class CitiesController {

    static $inject = ["$http"];

    prefectures: Prefecture[];

    constructor($http: angular.IHttpService) {
        $http.get<Prefecture[]>(`${apiRoot}/cities`).success((result) => {
            this.prefectures = result;
        });
    }


}

angular.module('hp').controller('CitiesController', CitiesController);



// WEBPACK FOOTER //
// ./controllers/CitiesController.ts